import { DEBUG_QUERY_STRING } from '@wyz/utils';
import * as React from 'react';
import { isNil } from 'lodash-es';
import { useSearchParams } from 'react-router';
import { useAuth } from 'react-oidc-context';
import { ROLES, isGranted } from '~/common/helpers';
import { IUserAuth } from '~/common/types';

// eslint-disable-next-line @wyz/module/no-relative-import
import { DebugContext } from './contexts';

export function DebugProvider(props: React.PropsWithChildren) {
  const [searchParam] = useSearchParams();
  const auth = useAuth();
  const isDebugModeRef =
    !isNil(searchParam.get(DEBUG_QUERY_STRING)) &&
    isGranted(
      (auth.user as unknown as IUserAuth)?.profile.realm_access.roles ?? [],
      [ROLES.ROLE_SUPER_ADMIN],
      'unanimous',
    );
  return (
    <DebugContext.Provider value={isDebugModeRef}>
      {props.children}
    </DebugContext.Provider>
  );
}

export const useDebugContext = () => {
  const context = React.useContext(DebugContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a DebugContext');
  }
  return context;
};
